import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AutoLoginGuard } from './core/guards/auto-login.guard';
import { AuthorizedGuard } from './core/guards/authorized.guard';
import { IntegracaoProdutosComponent } from './pages/integracao/integracaoprodutos.page';
import { TaxaEntregaComponent } from './pages/taxa-entrega/taxa-entrega.component';
import { CadastroPerguntasPage } from './pages/cadastro-perguntas/cadastro-perguntas.page';
import { IntegracaoPizzaLasanha } from './shared/components/integracao-pizza-lasanha/integracao-pizza-lasanha.component';
import { ConfiguracaoImpressaoComponent } from './pages/configuracao-impressao/configuracao-impressao.page';

const routes: Routes = [
    {
        path: 'login',
        loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule),
        canLoad: [AutoLoginGuard]
    },
    {
        path: 'home',
        loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
        canLoad: [AuthorizedGuard]
    },
    {
        path: 'integracao',
        component: IntegracaoProdutosComponent,
        canLoad: [AuthorizedGuard]
    },
    {
        path: 'configuracao-impressao',
        component: ConfiguracaoImpressaoComponent,
        canLoad: [AuthorizedGuard],
    },
    {
        path: 'taxa-entrega',
        component: TaxaEntregaComponent,
        canLoad: [AuthorizedGuard]
    },
    {
        path: 'perguntas/:codigoProduto',
        component: CadastroPerguntasPage,
        canLoad: [AuthorizedGuard]
    },
    {
        path: 'integracao-pizza-lasanha/:tipo',
        component: IntegracaoPizzaLasanha,
        canLoad: [AuthorizedGuard]
    },
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, useHash: true })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
